import SubHeader from "./SubHeader";
import SubFooter from "./SubFooter";
import RegistrationBtnGroup from "./RegistrationBtnGroup";
import SectionTitle from "../../components/SectionTitle";
import AboutItemSection from "../../components/about/AboutItemSection";

const contentComponentMap = {
  aboutItemSection: AboutItemSection,
  registrationBtnGroup: RegistrationBtnGroup,
};

const AboutBenkyoSection = ({ id, title, titleSpan, subtitle, content = [] }) => {
  return (
    <>
      <SubHeader />
      <div id={id} className="about-benkyo-section">
        <div className="container benkyo-section">
          <SectionTitle
            type="none"
            title={title}
            spantitle={titleSpan}
            subtitle={subtitle}
          />
          {(content || []).map((block, i) => {
            const Component = contentComponentMap[block._type];
            if (!Component) {
              console.warn(`Unknown about benkyo content type: ${block._type}`);
              return null;
            }

            switch (block._type) {
              case 'aboutItemSection':
                return (
                  <Component
                    key={block._key || i}
                    item={{ en: block.en, jp: block.jp, items: block.items || [] }}
                  />
                );
              case 'registrationBtnGroup':
                return (
                  <Component
                    key={block._key || i}
                    buttons={block.buttons}
                  />
                );
              default:
                return null;
            }
          })}
        </div>
      </div>
      <SubFooter />
    </>
  );
};

export default AboutBenkyoSection;
